/**
 * MIRA Textarea Component
 * Wraps Shadcn Textarea with MIRA design system styles
 */

import React from 'react';
import { Textarea as ShadcnTextarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/textarea.module.css';

export const Textarea = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTextarea
        ref={ref}
        className={cn(styles.miraTextarea, className)}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'MiraTextarea';
